/** Display only the ids/counts needed for review, never an arbitrary raw payload. */
export function signupReviewEvidence(detail: unknown) {
  let value: any = detail;
  if (typeof value === "string") {
    try { value = JSON.parse(value); } catch { value = null; }
  }
  const positive = (raw: unknown): number | null => {
    if (typeof raw !== "number" && !(typeof raw === "string" && /^[1-9]\d*$/.test(raw))) return null;
    const number = Number(raw);
    return Number.isSafeInteger(number) && number > 0 ? number : null;
  };
  return {
    matchedTalentId: positive(value?.matchedHygienistId),
    accounts: positive(value?.accounts),
    conflicts: positive(value?.conflicts)
  };
}
